import { render, staticRenderFns } from "./topCenter.vue?vue&type=template&id=5f84a546&scoped=true"
import script from "./topCenter.vue?vue&type=script&lang=js"
export * from "./topCenter.vue?vue&type=script&lang=js"
import style0 from "./topCenter.vue?vue&type=style&index=0&id=5f84a546&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f84a546",
  null
  
)

export default component.exports